import React, { Component } from 'react'
import { Pagination } from 'antd'
import { COLORSPACE_OPTIONS, PRINTER_OPTIONS } from '../helper/labelFilters'
import SearchField from '../../home/components/filters/SearchField'
import FilterSelect from "../../shared/FilterSelect"
import OriginalFilesTable from './table/OriginalFilesTable'
import { getListOriginalFiles } from '../../../services/api/originalFilesManagementServices'

const _getFiltersFromSearch = (search) => {
    try {
        const params = new URLSearchParams(search || '')
        const barcode = params.get('barcode')
        if (barcode) {
            return { barcodes: barcode }
        }
    } catch (e) {
        console.warn('Failed to parse URL search params:', e)
    }
    return {}
}

class OriginalFileManagementPage extends Component {
    state = {
        originalFiles: [],
        total: 0,
        limit: 50,
        page: 1,
        pages: 1,
        loading: false,
        error: '',
        filters: _getFiltersFromSearch((this.props.location && this.props.location.search) || window.location.search),
    }

    componentDidMount() {
        this._fetchOriginalFiles()
    }

    componentDidUpdate(prevProps) {
        const prevSearch = prevProps.location && prevProps.location.search
        const currSearch = this.props.location && this.props.location.search
        if (prevSearch !== currSearch) {
            const nextFilters = _getFiltersFromSearch(currSearch)
            this.setState({ filters: nextFilters, page: 1 }, this._fetchOriginalFiles)
        }
    }

    _fetchOriginalFiles = async () => {
        this.setState({
            loading: true,
        })

        try {
            const { limit, page, filters } = this.state
            const payload = {
                limit,
                page,
                ...filters,
            }
            const { data, success, message } = await getListOriginalFiles(payload)

            if (!success) {
                throw new Error(message)
            }

            const { data: originalFiles, total, pages } = data

            this.setState({
                originalFiles: originalFiles,
                total,
                pages,
                loading: false,
                error: '',
            })
        } catch (e) {
            this.setState({
                loading: false,
                error: e.message,
            })
        }
    }

    _handlePageChange = (current) => {
        this.setState({
            page: current,
        }, this._fetchOriginalFiles)
    }

    _handleShowSizeChange = (current, size) => {
        this.setState({
            limit: size,
            page: 1,
        }, this._fetchOriginalFiles)
    }

    _handleChange = (field, value) => {
        this.setState(({ filters }) => {
            return {
                filters: {
                    ...filters,
                    [field]: value,
                },
                page: 1,
            }
        }, this._fetchOriginalFiles)
    }

    _handleChangeInput = (field, value) => {
        this.setState(({ filters }) => {
            return {
                filters: {
                    ...filters,
                    [field]: value,
                },
                page: 1,
            }
        }, this._fetchOriginalFiles)
    }

    render() {
        const { originalFiles, error, page, total, limit, loading } = this.state
        return (
            <div className='OriginFileManagementPage'>
                <div className='container-fluid min-vh-100'>
                    <div className='col-12 mx-auto bg-white shadow-sm py-3'>
                        <div className='mb-3 d-flex justify-content-between mt-3'>
                            <h3 className='mb-0'>Quản lý file in theo hệ màu và máy in</h3>
                        </div>
                        <div className='jumbotron p-3 mb-3'>
                            <div className='row align-items-end'>
                                <div className='col-12 col-xl-auto'>
                                    <label className='font-weight-bold mb-1'>Barcode</label>
                                    <SearchField
                                        key={this.state.filters.barcodes || ''}
                                        field='barcodes'
                                        placeholder='Tìm theo barcode...'
                                        defaultValue={this.state.filters.barcodes || ''}
                                        onChangeInput={this._handleChangeInput}
                                    />
                                </div>

                                <div className='col-12 col-xl-auto'>
                                    <FilterSelect
                                        label={'Hệ màu in:'}
                                        options={COLORSPACE_OPTIONS}
                                        defaultValue=''
                                        field='colorspace'
                                        onChange={this._handleChange}
                                        value={this.state.filters.colorspace || ''}
                                    />
                                </div>

                                <div className='col-12 col-xl-auto'>
                                    <FilterSelect
                                        label={'Loại máy in:'}
                                        options={PRINTER_OPTIONS}
                                        defaultValue=''
                                        field='printer'
                                        value={this.state.filters.printer || ''}
                                        onChange={this._handleChange}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="d-flex justify-content-between align-items-center mb-3 headPagination">
                            <div>
                                {error && <div className='text-danger'>{error}</div>}
                            </div>
                            <Pagination
                                current={page}
                                total={total}
                                pageSize={limit}
                                className='text-right' showSizeChanger
                                pageSizeOptions={['10', '20', '50', '100']}
                                showTotal={(sum, range) => sum > 0 &&
                                    <div>
                                        {`Hiển thị ${range[0]} đến ${range[1]} của `}<strong>{`${total} files`}</strong>
                                    </div>}
                                onChange={this._handlePageChange}
                                onShowSizeChange={this._handleShowSizeChange}
                            />
                        </div>

                        <OriginalFilesTable
                            originalFiles={originalFiles}
                            error={error}
                            loading={loading}
                            onFetchFiles={this._fetchOriginalFiles}
                            onChange={this._handleChange}
                        />

                        <Pagination
                            current={page}
                            total={total}
                            pageSize={limit}
                            className='text-right'
                            showSizeChanger
                            pageSizeOptions={['10', '20', '50', '100']}
                            onChange={this._handlePageChange}
                            onShowSizeChange={this._handleShowSizeChange}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default OriginalFileManagementPage
